import { AsyncDataGrid } from "src/components/common/dataGrid/AsyncDataGrid.tsx";
import { InvoiceLine } from "src/api/generated/erp/db/types/tables/invoiceLine.ts";
import { InvoiceReadingApi } from "src/api/generated/erp/sales/invoicing/api/invoiceReadingApi.ts";
import { textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { dataGridPersistentStateProps } from "src/components/common/dataGrid/dataGridStateStorage.ts";
import { InvoiceView } from "src/api/generated/erp/db/types/tables/invoiceView.ts";

export interface InvoiceLinesDataGridProps {
	invoice: InvoiceView;
}

export const InvoiceLinesDataGrid = ({ invoice }: InvoiceLinesDataGridProps) => {
	return (
		<AsyncDataGrid<InvoiceLine>
			fetchRows={() => InvoiceReadingApi.getInvoiceLines({ invoiceId: invoice.invoiceId })}
			getRowId={(row) => row.invoiceLineId}
			hideRefreshButton
			columns={[
				textColumn({
					field: "salesPart",
					headerName: i18n.t("sales_part"),
					width: 150,
				}),
				textColumn({
					field: "mark",
					headerName: i18n.t("mark"),
				}),
				textColumn({
					field: "quantityInSalesUnits",
					headerName: i18n.t("quantity_in_sales_units"),
					width: 180,
				}),
				textColumn({
					field: "salesUnit",
					headerName: i18n.t("sales_unit"),
				}),
				textColumn({
					field: "quantityInPriceUnits",
					headerName: i18n.t("quantity_in_price_units"),
					width: 180,
				}),
				textColumn({
					field: "priceUnit",
					headerName: i18n.t("price_unit"),
				}),
				textColumn({
					field: "unitPrice",
					headerName: i18n.t("unit_price_in_price_units"),
					width: 200,
				}),
				textColumn({
					field: "discountPercent",
					headerName: i18n.t("discount_percent"),
				}),
				textColumn({
					field: "totalPrice",
					headerName: i18n.t("sum_without_vat"),
					width: 150,
				}),
				textColumn({
					field: "totalVat",
					headerName: i18n.t("vat"),
				}),
				textColumn({
					field: "totalPriceWithVat",
					headerName: i18n.t("sum_with_vat"),
					width: 150,
				}),
				textColumn({
					field: "salesAccountingCode",
					headerName: i18n.t("accounting_code"),
				}),
			]}
			{...dataGridPersistentStateProps("C128689FC7163A61")}
		/>
	);
};
